(function () {
  "use strict";

  var NS = (window.ZeusModal = window.ZeusModal || {});
  var openOverlay = null;
  var lastFocus = null;
  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function getOverlay(id) {
    return document.getElementById(id);
  }

  function getPanel(overlay) {
    return overlay ? overlay.querySelector("[data-zeus-modal-panel]") : null;
  }

  function getFocusable(container) {
    if (!container) return [];
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
      ),
    );
  }

  function lockScroll() {
    document.body.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.body.style.overflow = "";
  }

  function animateOpen(overlay) {
    var panel = getPanel(overlay);
    if (!panel) return;
    overlay.hidden = false;
    overlay.classList.add("is-open");
    if (reducedMotion) {
      panel.classList.add("is-visible");
      return;
    }
    requestAnimationFrame(function () {
      panel.classList.add("is-visible");
    });
  }

  function animateClose(overlay, done) {
    var panel = getPanel(overlay);
    if (!panel) {
      if (done) done();
      return;
    }
    overlay.classList.remove("is-open");
    panel.classList.remove("is-visible");
    if (reducedMotion) {
      overlay.hidden = true;
      if (done) done();
      return;
    }
    var onEnd = function (e) {
      if (e.target !== panel) return;
      panel.removeEventListener("transitionend", onEnd);
      overlay.hidden = true;
      if (done) done();
    };
    panel.addEventListener("transitionend", onEnd);
    window.setTimeout(function () {
      panel.removeEventListener("transitionend", onEnd);
      if (!overlay.hidden && !overlay.classList.contains("is-open")) {
        overlay.hidden = true;
        if (done) done();
      }
    }, 400);
  }

  NS.open = function (id) {
    var overlay = getOverlay(id);
    if (!overlay || openOverlay === overlay) return;

    if (openOverlay) {
      NS.close(openOverlay.id);
    }

    lastFocus = document.activeElement;
    openOverlay = overlay;
    lockScroll();
    animateOpen(overlay);
    if (window.ZeusOverlayLock) window.ZeusOverlayLock.sync();

    overlay.querySelectorAll(".zeus-perf-rbar, .zeus-reveal").forEach(function (el) {
      el.classList.add("is-visible");
    });

    requestAnimationFrame(function () {
      var panel = getPanel(overlay);
      var focusable = getFocusable(panel);
      if (focusable.length) {
        focusable[0].focus();
      } else if (panel) {
        panel.focus();
      }
    });
  };

  NS.close = function (id) {
    var overlay = id ? getOverlay(id) : openOverlay;
    if (!overlay) return;

    animateClose(overlay, function () {
      if (openOverlay === overlay) {
        openOverlay = null;
        unlockScroll();
        if (lastFocus && typeof lastFocus.focus === "function") {
          lastFocus.focus();
        }
        lastFocus = null;
        if (window.ZeusOverlayLock) window.ZeusOverlayLock.sync();
      }
    });
  };

  NS.init = function () {
    if (NS._bound) return;
    NS._bound = true;

    document.addEventListener("click", function (e) {
      var openTrigger = e.target.closest("[data-zeus-modal-open]");
      if (openTrigger) {
        e.preventDefault();
        var modalId = openTrigger.getAttribute("data-zeus-modal-open");
        if (modalId) NS.open(modalId);
        return;
      }

      var closeTrigger = e.target.closest("[data-zeus-modal-close]");
      if (closeTrigger) {
        e.preventDefault();
        var overlay = closeTrigger.closest("[data-zeus-modal-overlay]");
        if (overlay) NS.close(overlay.id);
        return;
      }

      if (e.target.matches("[data-zeus-modal-overlay].is-open")) {
        NS.close(e.target.id);
      }

      var sizeTab = e.target.closest("[data-zeus-size-guide-tab]");
      if (sizeTab && sizeTab.closest("[data-zeus-size-guide]")) {
        e.preventDefault();
        var guideRoot = sizeTab.closest("[data-zeus-size-guide]");
        var sizeIndex = sizeTab.getAttribute("data-size-index");
        if (!guideRoot || sizeIndex == null) return;

        guideRoot.querySelectorAll("[data-zeus-size-guide-tab]").forEach(function (tab) {
          var isActive = tab.getAttribute("data-size-index") === sizeIndex;
          tab.classList.toggle("is-current", isActive);
          tab.setAttribute("aria-selected", isActive ? "true" : "false");
        });

        guideRoot.querySelectorAll("[data-zeus-size-guide-panel]").forEach(function (panel) {
          var isActive = panel.getAttribute("data-size-index") === sizeIndex;
          panel.classList.toggle("is-active", isActive);
          if (isActive) {
            panel.removeAttribute("hidden");
          } else {
            panel.setAttribute("hidden", "");
          }
        });
      }
    });

    document.addEventListener("keydown", function (e) {
      var sizeTabKey = e.target.closest("[data-zeus-size-guide-tab]");
      if (!sizeTabKey || !sizeTabKey.closest("[data-zeus-size-guide]")) return;
      var navKeys = ["ArrowLeft", "ArrowRight", "Home", "End"];
      if (navKeys.indexOf(e.key) === -1) return;
      e.preventDefault();
      var guideRoot = sizeTabKey.closest("[data-zeus-size-guide]");
      var tabs = Array.prototype.slice.call(guideRoot.querySelectorAll("[data-zeus-size-guide-tab]"));
      var idx = tabs.indexOf(sizeTabKey);
      var nextIdx;
      if (e.key === "Home") nextIdx = 0;
      else if (e.key === "End") nextIdx = tabs.length - 1;
      else if (e.key === "ArrowLeft") nextIdx = (idx - 1 + tabs.length) % tabs.length;
      else nextIdx = (idx + 1) % tabs.length;
      var nextTab = tabs[nextIdx];
      if (!nextTab) return;
      nextTab.focus();
      nextTab.click();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !openOverlay) return;
      NS.close(openOverlay.id);
    });

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Tab" || !openOverlay) return;
      var panel = getPanel(openOverlay);
      if (!panel) return;
      var focusable = getFocusable(panel);
      if (focusable.length < 2) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", NS.init);
  } else {
    NS.init();
  }
})();
